'use strict';

import {addSelectedCompanyHandler, getSelectedCompany, popupCenterDual} from "../jquery-functions-library";
import moment from "moment";
import {element_exists, redesignDataTablesHeader} from "../functions";

function isClient() {
    return $('body').attr('data-company') !== undefined;
}

export var fnPaySlipsTable = function () {

    //TODO maybe remove column
    var contentColumn = '.pay-slip-col';

    if (!element_exists(contentColumn)) return false;

    loadEmployeeSlips();

    addSelectedCompanyHandler(loadEmployeeSlips);

    function loadEmployeeSlips() {

        var selectedCompany = getSelectedCompany();

        var companyGuard = selectedCompany !== 'default';

        var tableName = '#datatable-pay-slips';

        if (companyGuard) {

            var url = '/salary/pay-slips/' + selectedCompany + '/load'; //Beware - this is undefined when client is logged in.


            if ($.fn.dataTable.isDataTable(tableName)) {
                $(tableName).parents('.table-responsive').removeClass('hidden');
                $(contentColumn).removeClass('hidden');
                $(tableName).DataTable().ajax.url(url).load(function () {
                    setTimeout(function () {
                        $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                    }, 500);
                });
                return;
            }

            var columns = [
                {data: 'id'},
                {data: 'select'},
                {data: 'year'},
                {data: 'month'},
                {
                    data: function (data) {
                        var type = allLangFiles.salary.excel.types[data.payroll.type];
                        return type !== undefined ? type : '-';
                    }
                },
                {data: 'name'},
                {data: 'comment'},
                {data: 'status_text'},
                {data: 'filename'},/*TODO blob filename*/
                {
                    data: 'last_reminded_at', render: function (data) {
                        if (!data) return 'Ingen påmindelse sendt';
                        var date = moment(data);
                        return date.format('DD/MM/YYYY');
                    }
                },
                {data: 'actions'},
            ];

            /*Rules for filling the columns*/
            var columnDefs = [
                {visible: false, targets: 0, orderable: false},
                {
                    orderable: false,
                    checkboxes: {
                        selectRow: true,
                    },
                    className: 'select-checkbox-gyro dt-center',
                    targets: 1,
                },
                {className: "dt-right", width: "20%", targets: 2},
                {className: "dt-right", width: "5%", targets: 3},
                {className: "dt-right", width: "5%", targets: 4},
                {width: "5%", targets: 5},
                {
                    render: function (data, type, full, meta) {
                        return "<div class='text-wrap width-300'>" + data + "</div>";
                    },
                    targets: 6
                },
                {width: "10%", targets: 7},
                {width: "10%", targets: 8},
                {width: "10%", className: 'dt-right', targets: 9},
                {width: "10%", targets: 10},
            ];

            /*Important otherwise table misaligned*/
            $(tableName).css('width', '100%');


            var table = $(tableName).DataTable({

                language: allLangFiles.datatables,
                rowId: 'id',
                ajax: {
                    url: url,
                    dataSrc: function (json) {
                        return json.data;
                    },
                },
                select: {
                    style: 'multi',
                    selector: 'td:first-child',
                    info: false,
                },
                columns: columns,
                columnDefs: columnDefs,
                order: [[2, "desc"], [3, "desc"]],
                scrollX: true,

                lengthMenu: [10, 25, 50, 75, 100],
                initComplete: function (settings, json) {
                    $(tableName).parents('.table-responsive').removeClass('hidden');
                    $(contentColumn).removeClass('hidden');

                    table.draw();
                },
                drawCallback: function (settings) {
                    $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                },
            });

            openPaySlipOnClick(table)
            const { $filterButtons } = redesignDataTablesHeader(tableName, true)
            $filterButtons.prepend($('#btn-pay-slip-send-reminder'));
        }
        else {
            $(tableName).parents('.table-responsive').addClass('hidden');
            $(contentColumn).addClass('hidden');
            $(tableName).DataTable().clear().draw();
        }
    }

    function openPaySlipOnClick(table) {

        var btnOpen = '.btn-open-pay-slip';

        $(document).off('click', btnOpen);
        $(document).on('click', btnOpen, function (e) {
            e.preventDefault();

            var data = table.row($(this).parents('tr')).data();

            if (!data.read_by_client && isClient()) {
                markPayslipAsRead(data.id, table);
            }

            popupCenterDual('pay-slips/' + data.id + '/get', data.filename, window.innerWidth / 2, window.innerHeight / 1.2);
        });
    }

    function markPayslipAsRead(id, table) {
        $.ajax({
            method: 'POST',
            url: '/salary/pay-slips/mark-as-read',
            data: {id: id},
            success: function (response) {
                table.ajax.reload(null, false);
            },
            error: function (response) {
            }
        });
    }

};